import type { AdminMockRequestHandler } from './mock-api-admin.handlers';

import { of } from 'rxjs';

import { HttpResponse } from '@angular/common/http';

function ok<T>(data: T) {
  return { errors: [] as { code: string; messageKey: string }[], data, success: true };
}

/** GET /api/health — contrato: docs/contracts/api/health/get-health.md */
export const mockApiHealthHandlers: AdminMockRequestHandler[] = [
  {
    method: 'GET',
    path: /^\/api\/health$/,
    handle: () =>
      of(
        new HttpResponse({
          body: ok({ database: { status: 'Healthy' }, status: 'Healthy' }),
          status: 200,
        }),
      ),
  },
];
